export function scrollToTop(scrollDuration: number): void {
  if (!window.requestAnimationFrame) {
    window.scrollTo(0, 0);

    return;
  }

  const cosParameter = window.scrollY / 2;
  let scrollCount = 0;
  let oldTimestamp: number;

  function step(newTimestamp: number = 200) {
    if (oldTimestamp) {
      scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
      if (scrollCount >= Math.PI) {
        window.scrollTo(0, 0);
      }
      if (window.scrollY === 0) {
        return;
      }

      window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
    }
    oldTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);
}
